import MockAdapter from 'axios-mock-adapter'
import {camelizeKeys} from 'humps'

import {apiPrefix} from '../../config'
import active from './active'

const createPath = (path) => new RegExp(`(${apiPrefix})?${path}$`)

const mockApi = (mock, configs) => {
  const confs = Array.isArray(configs) ? [...configs] : [configs]
  confs.forEach((conf) => {
    const {method = 'post', path, status = 200, data, headers, delay = 0} = conf
    const methodName = `on${method.charAt(0).toUpperCase()}${method
      .slice(1)
      .toLowerCase()}`

    mock[methodName](createPath(path)).reply((params) => {
      const arg = {...params, data: camelizeKeys(JSON.parse(params.data))}
      const response = [status, data, headers].map((field) =>
        typeof field === 'function' ? field(arg) : field
      )
      if (!delay) {
        return response
      }
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(response)
        }, delay)
      })
    })
  })
}

const initMock = (axios) => {
  const mock = new MockAdapter(axios)

  mockApi(mock, active)
  // mockApi(mock, backpack)
  // mockApi(mock, wallet)
  // mockApi(mock, charm)
  mock.onAny().passThrough()
}

export {initMock as default}
